import './index.css'
import React from 'react';
import InputLabel from '../common/InputLabel';
import { CompanyForm } from '../../models/company.model';


interface BasicDataProps {
  action: string;
  handleChange: (e: any) => void;
  companyForm: CompanyForm
}

const BasicData: React.FC<BasicDataProps> = ({ action, handleChange, companyForm }) => {

  return (
    <React.Fragment>
      <div className='company-form-section'>
        <div className='company-form-section-title'>
          <p>DATOS BÁSICOS</p>
        </div>

        <div className='company-form-section-item'>
          <InputLabel
            label='Nombre'
            placeholder="Nombre"
            disabled={action === 'view'}
            name='name'
            value={companyForm.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className='company-form-section-item'>
          <InputLabel
            label='Teléfono'
            placeholder="Teléfono"
            disabled={action === 'view'}
            name='phone_number'
            value={companyForm.phone_number}
            onChange={handleChange}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

export default BasicData;